// 主页
<template>
  <div class="mainArea CIndex">
    <p>欢迎登录{{$store.state.currentServerInfo.title}}</p>
    <!-- <router-link to="/CMap" class="btn-map" v-if="isfunMap">仪表盘</router-link> -->
  </div>
</template>

<script>

  export default {
    name: 'CIndex',
    data() {
      return {
        // isfunMap: false
      }
    },
    created () {
      // console.log('tag', this.$route.path)
      // this.isfunMap = this.$store.state.isfunMap
    },
    mounted() {
    },
    methods: {
    },
    watch: {
      // '$store.state.isfunMap': function(newVal){
      //   this.isfunMap = newVal
      // }
    },
  }
</script>

<style lang="scss" scoped>
.mainArea.CIndex {
    padding-top: 20%;
    text-align: center;
    font-size: 36px;
    // color: #03a9f4;
    color: #1890ff;
    position: relative;
    .btn-map {
      display: block;
      width: 105px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      background-color: #0771F1;
      color: #ffffff;
      border-radius: 5px;
      position: absolute;
      right: 40px;
      top: 35px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CIndex.vue